import Link from "next/link";

import ArticleBoard from "./ArticleBoard";
import { Section } from "../util/section";

const DEFAULT_POSITION =
  "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";

export default function LessonOpeningReference({ lesson }: { lesson: any }) {
  return (
    <Section className="flex-1 bg-white">
      <article className="mx-auto w-full max-w-[820px] px-6 py-10 sm:py-12">
        <header className="mb-8">
          <Link
            href="/openings"
            locale={false}
            className="inline-block mb-3 text-xs font-bold uppercase tracking-[0.18em] text-altblue-600 transition-colors hover:text-altblue-800"
          >
            Openings
          </Link>
          <h1 className="text-3xl font-extrabold leading-tight text-slate-900 sm:text-4xl lg:text-[42px]">
            {lesson.lesson}
          </h1>
          {lesson.description && (
            <p className="mt-3 text-xl leading-relaxed text-slate-500 md:text-[22px]">
              {lesson.description}
            </p>
          )}
        </header>

        <ArticleBoard
          fen={lesson.openingFen || DEFAULT_POSITION}
          playingWhite={lesson.playingWhite ?? true}
          caption={`${lesson.lesson} starting position`}
          presentation="hero"
        />

        <div className="rounded-xl border border-slate-200 bg-slate-50 p-5 sm:p-6">
          <h2 className="text-xl font-bold text-slate-900">
            About this opening
          </h2>
          {lesson.introText && (
            <p className="mt-3 text-base leading-7 text-slate-600">
              {lesson.introText}
            </p>
          )}
          <div className="mt-5 flex flex-wrap items-center gap-4">
            <Link
              href={`/learn/openings/${lesson.slug}`}
              locale={false}
              className="inline-flex items-center rounded-lg bg-altblue-600 px-4 py-2.5 text-sm font-bold text-white transition-colors hover:bg-altblue-700"
            >
              Practice this opening
              <span className="ml-2" aria-hidden="true">
                →
              </span>
            </Link>
            <Link
              href="/openings"
              locale={false}
              className="text-sm font-bold text-slate-600 hover:text-slate-900"
            >
              Browse all openings
            </Link>
          </div>
        </div>
      </article>
    </Section>
  );
}
